import { Field } from '../../../../environments/field';
import { environment } from '../../../../environments/environment';

let token = sessionStorage.getItem('token');

export let fields: Array<Field> = [
  {
    type: 'text',
    name: 'numero_cliente',
    label: 'Numero de cliente',
    value: '',
    validfield: true,
    required: true,
    width: 'col-md-6',
  },
  {
    type: 'text',
    name: 'cuenta_contable',
    label: 'Cuenta contable',
    value: '',
    validfield: true,
    required: true,
    width: 'col-md-6',
  },
  {
    type: 'text',
    name: 'nombre',
    label: 'Nombre',
    value: '',
    validfield: true,
    required: true,
    width: 'col-md-6',
  },
  {
    type: 'text',
    name: 'ofv',
    label: 'Oficina de ventas',
    value: '',
    validfield: true,
    required: true,
    width: 'col-md-6',
  },
  {
    type: 'text',
    name: 'av',
    label: 'Área de ventas',
    value: '',
    validfield: true,
    required: true,
    width: 'col-md-6',
  },
  {
    type: 'select',
    name: 'coordinador',
    label: 'Coordinador',
    value: '',
    validfield: true,
    required: true,
    width: 'col-md-6',
    api:'trabajadors',
  },
  {
    type: 'select',
    name: 'pcn',
    label: 'Almacenista',
    value: '',
    validfield: true,
    required: true,
    width: 'col-md-6',
    api:'trabajadors',
  },

  ];
